module.exports = __webpack_public_path__ + "img/cycle-1_a.fd9e81b5.png";